export default class Ownership {
    id: number;
    decimalInterest: number;
    ownershipType: string;
    isCommunityProperty?: boolean;
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/Ownership.ts